import { Component } from '@angular/core';
import { RUPComponent } from './../core/rup.component';

@Component({
    selector: 'rup-nueva-evolucion-problema',
    templateUrl: 'nuevaEvolucionProblema.html'
})

export class NuevaEvolucionProblemaComponent extends RUPComponent {
    public fechaInicio: Date;
    public HallazgoCompleto;
    public unaEvolucion;
    public indice = 0;
    public evoluciones;

    // estadoActual: any = { id: 'activo', nombre: 'Activo' };
    inicioEstimadoUnidad: any = null;
    inicioEstimadoTiempo: any = { id: 'dias', nombre: 'Día(s)' };
    estados = [{ id: 'resuelto', nombre: 'Resuelto' }, { id: 'inactivo', nombre: 'Inactivo' }, { id: 'activo', nombre: 'Activo' }];
    unidadTiempo = [{ id: 'anios', nombre: 'Año(s)' }, { id: 'mes', nombre: 'Mes(es)' }, { id: 'semanas', nombre: 'Semana(s)' }, { id: 'dias', nombre: 'Día(s)' }];


    /* los atomos por defecto se inicializan en null porque generalmente tienen un solo input
     * al ser este un caso de atomo medio particular que lleva muchas propiedades dentro
     * entonces inicializamos data como un objeto
     */

}
